






























import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Header extends Vue {
  circleUrl: string = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
  visible: boolean = false
  get account(): Object {
    const account: any = localStorage.getItem('enterprise')
    return JSON.parse(account)
  }

  get isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  }

  logout() {
    this.visible = false
    localStorage.removeItem('enterprise')
    localStorage.removeItem('enterpriseToken')
    this.$message({
      message: '退出成功！',
      type: 'success'
    })
    this.$router.push('/login')
  }

  changePass() {
    this.$router.push({ name: 'change-password' })
  }
}
